import type { TraceErrorObject } from 'owa-trace';

const errorsToIgnore = ['requestnotcomplete', 'requesttimeout'];

export function isNonTransientError(error: Error): boolean {
    const traceError = error as TraceErrorObject;
    const errorType = traceError?.fetchErrorType?.toLowerCase() ?? '';
    return errorsToIgnore.indexOf(errorType) == -1;
}
